export default {
  goodDeals: {
    id: 'menu_good_deals',
    defaultMessage: 'Good deals',
  },
  holidays: {
    id: 'menu_holidays',
    defaultMessage: 'Holidays',
  },
}
